export default "__VITE_ASSET__cpX4AtaX__"